import axios from "axios";
import { Survey } from "../models/Survey";
import { Question } from "../models/Question";
import { SurveyConverter } from "../utils/data-conversion/surveyConverter";
import { QuestionsConverter } from "../utils/data-conversion/questionsConverter";

/**
 * Servicio optimizado que carga survey y questions con una sola petición HTTP compartida
 */
export class OptimizedDataService {
  private static singleSurveyFullURL: string =
    "https://survey-app-backend.azurewebsites.net/api/surveys/singleSurveyFull";
  private static singleSurveyWithRURL: string =
    "https://survey-app-backend.azurewebsites.net/api/surveys/singleSurveyWithR";

  /**
   * Carga survey y questions en paralelo, compartiendo las peticiones HTTP
   */
  public static async getSurveyAndQuestions(
    surveyId: string
  ): Promise<{ survey: Survey; questions: Question[] }> {
    // Hacer ambas peticiones HTTP en paralelo (solo 2 peticiones en lugar de 4)
    const [singleSurveyFull, singleSurveyWithR] = await Promise.all([
      axios.get(this.singleSurveyFullURL + "/" + surveyId).then(res => res.data),
      axios.get(this.singleSurveyWithRURL + "/" + surveyId).then(res => res.data)
    ]);

    // Procesar survey
    const surveyConverter = new SurveyConverter(
      singleSurveyFull,
      singleSurveyWithR,
      "teams"
    );
    surveyConverter.generateSurvey();
    const survey = surveyConverter.getSurvey();

    // Procesar questions usando los mismos datos
    const questionsConverter = new QuestionsConverter(
      singleSurveyFull,
      singleSurveyWithR,
      "teams"
    );
    questionsConverter.generateQuestions();
    const questions = questionsConverter.getQuestions();

    console.log("Optimized load - survey:", survey);
    console.log("Optimized load - questions:", questions);

    return { survey, questions };
  }
}
